;(function ($) {
  'use strict'

  //Opens/Closes burger menu on click.

  $('#menu-trigger').click(function () {
    $(this).toggleClass('animate')
    $('.nav-container').toggleClass('active-nav')
    $('body, html').toggleClass('show')
  })
  $('.menu li a').on('click', function () {
    $('.nav-container').removeClass('active-nav')
    $('#hamburger').removeClass('animate')
    $('body, html').removeClass('show')
  })
  
  $('.nav-container-desktop .menu-item.dead a').first().click(function(e){e.preventDefault();});

  $('.nav-container-desktop').first().removeClass('hide');

//   $('.current-menu-item').find('.sub-menu').addClass('show-sub-menu');

  $('.nav-container-desktop li.menu-item-has-children').find('.sub-menu').addClass('hide-sub-menu');

  $('.nav-container-desktop li.menu-item').mouseenter(function () {
	$(this).find(' > .sub-menu').addClass('show-sub-menu')
  })

  $('.nav-container-desktop li.menu-item').mouseleave(function () {
    $(this).find('.sub-menu').removeClass('show-sub-menu')
  })

  $('.nav-container-desktop li.menu-item').mouseenter(function () {
	$(this).find('> a').addClass('active-parent');
  })

  $('.nav-container-desktop li.menu-item').mouseleave(function () {
	$(this).find('a').removeClass('active-parent');
  })

  // Scroll to second section

  $("a[href='#intro']").click(function () {
    $('html, body').animate({ scrollTop: $('#intro').offset().top -125 }, 800)
    return false
  })

  // Scroll top

  $("a[href='#top']").click(function () {
    $('html, body').animate({ scrollTop: 0 }, 'slow')
    return false
  })

  // Start marquee
  $('.ticker-tape__text').marquee({
    direction: 'left',
    gap: 10,
    delayBeforeStart: 0,
    duplicated: true,
    startVisible: true,
	speed: 50,
  })

  const swiper = new Swiper('.be-inspired__slider .swiper-container', {
    loop: true,
    autoHeight: true,
	slidesPerView: 'auto',

    navigation: {
      nextEl: '.be-inspired__slider .slider-next',
      prevEl: '.be-inspired__slider .slider-prev',
    },
  })

  // Search - Show/Hide
  $('.search--trigger').click(function() {
    $('.search-form').toggleClass('show-search');
    setTimeout(function() {$('input.search-field').focus();}, 0);
    $('body, html').toggleClass('show');
  }); 

  $('#close-search').click(function() {
      $('.search-form').toggleClass('show-search');
      $('body, html').toggleClass('show');
  });


  // Click event to show/hide video modal
  $('.modal-trigger').on('click', function () {
    $('.intro__video').addClass('active-modal')
    $('body, html').addClass('show')
  });

  $('.close-icon').on('click', function () {
    $('.intro__video').removeClass('active-modal')
    $('body, html').removeClass('show')
  });

	$('.show-comments').on('click', function(e) {
		let comments = $('#comments-wrapper');

		e.preventDefault();

		if ($(this).attr('data-status') == 'closed') {
			comments.fadeIn();
			$(this).attr('data-status', 'opened');
			$(this).html('Hide comments');
			return;
		}
		
		if ($(this).attr('data-status') == 'opened') {
			comments.fadeOut();
			$(this).attr('data-status', 'closed');
			$(this).html($(this).attr('data-label_closed'));
			return;
		}
	});

	// Checkbox "show past events" on event-index
	let chbx_inc_past_events = $('form ul li[data-sf-field-name="_sfm_sf_include_past_events"] ul li');
	chbx_inc_past_events.find('input').attr('name', 'sf_include_past_events');
	chbx_inc_past_events.find('label').html('Include past events');

})(jQuery);



// Section indicators 

(function ($) {
	/* Minimal modification of colourBrightness.js by Jamie Brittain - http://jamiebrittain.com */
	$.fn.bgIsBright = function () {
		var r,
			g,
			b,
			brightness,
			colour = this.css("background-color");

		if (colour.match(/^rgb/)) {
			colour = colour.match(/rgb\(([^)]+)\)/)[1];
			colour = colour.split(/ *, */).map(Number);
			r = colour[0];
			g = colour[1];
			b = colour[2];
		} else if ("#" == colour[0] && 7 == colour.length) {
			r = parseInt(colour.slice(1, 3), 16);
			g = parseInt(colour.slice(3, 5), 16);
			b = parseInt(colour.slice(5, 7), 16);
		} else if ("#" == colour[0] && 4 == colour.length) {
			r = parseInt(colour[1] + colour[1], 16);
			g = parseInt(colour[2] + colour[2], 16);
			b = parseInt(colour[3] + colour[3], 16);
		}

		brightness = (r * 299 + g * 587 + b * 114) / 1000;

		return brightness >= 125;
	};

	var win = $(window),
		doc = $(document);

	var useVelocity = $.fn.velocity;

	$.fn.sectionIndicators = function (options) {
		var settings = $.extend(
			{
				animDuration: 400,
				animEasing: "swing",
				containerId: "section-indicators",
				parentContainer: "body",
				indicatorClass: "section-indicator",
				currentIndicatorClass: "current",
				indicatorIcon: "fa-circle-o",
				indicatorIconActive: "fa-circle",
				indicatorIconHover: "fa-dot-circle-o",
				nextSectionClass: "next-section",
				nextSectionIcon: "fa-angle-down",
				prevSectionClass: "prev-section",
				prevSectionIcon: "fa-angle-up",
				spanClass: ""
			},
			options
		);

		var sections = $(this);

		function sectionInViewport(section) {
			if (!section.length) {
				return false;
			}

			var scrollTop = win.scrollTop(),
				sectionHeight = section.outerHeight(),
				sectionPos = section.offset().top;

			return (
				scrollTop >= sectionPos - win.height() / 2 &&
				scrollTop < sectionPos + sectionHeight - win.height() / 2
			);
		}

		$(settings.parentContainer).append(
			'<div id="' + settings.containerId + '"></div>'
		);

		var indicatorContainer = $("#" + settings.containerId);

		sections.each(function (i) {
			var sectionName = $(this).data("section-name")
				? $(this).data("section-name")
				: "Section " + (i + 1);
			indicatorContainer.append(
				'<a href="#" class="' +
					settings.indicatorClass +
					" fa " +
					settings.indicatorIcon +
					'"><span class="' +
					settings.spanClass +
					'">' +
					sectionName +
					"</span></a>"
			);
		});

		indicatorContainer
			.append(
				'<a href="#" class="fa ' +
					settings.nextSectionIcon +
					" " +
					settings.nextSectionClass +
					'"></a>'
			)
			.prepend(
				'<a href="#" class="fa ' +
					settings.prevSectionIcon +
					" " +
					settings.prevSectionClass +
					'"></a>'
			);

		var prevNav = $("." + settings.prevSectionClass);
		var nextNav = $("." + settings.nextSectionClass);

		sectionIndicators = $("." + settings.indicatorClass);

		var currSection = -1;

		var scrollingToCurr = false,
			hasIndicated = false;

		win.scroll(function () {
			hasIndicated = false;

			sections.each(function (i) {
				if (
					!hasIndicated &&
					sectionInViewport($(this)) &&
					!sectionInViewport(sections.eq(i + 1))
				) {
					sectionIndicators
						.eq(i)
						.addClass(
							settings.currentIndicatorClass + " " + settings.indicatorIconActive
						)
						.removeClass(settings.indicatorIcon);

					currSection = i;
					hasIndicated = true;

					if ($(this).bgIsBright()) {
						indicatorContainer.addClass("light").removeClass("dark");
					} else {
						indicatorContainer.addClass("dark").removeClass("light");
					}
				} else {
					sectionIndicators
						.eq(i)
						.removeClass(
							settings.currentIndicatorClass + " " + settings.indicatorIconActive
						)
						.addClass(settings.indicatorIcon);
				}
			});

			// If scrolled before first section or scrolled past last
			if (!hasIndicated) {
				if (win.scrollTop() < sections.eq(0).offset().top) {
					currSection = -1;
				} else {
					currSection = sections.length;
				}
			}
		});

		sectionIndicators
			.click(function (e) {
				e.preventDefault();

				var indicatorIndex = $("." + settings.indicatorClass).index($(this));

				if (useVelocity) {
					$("html").velocity("scroll", {
						offset: sections.eq(indicatorIndex).offset().top,
						duration: settings.animDuration,
						easing: settings.animEasing,
						mobileHA: false
					});
				} else {
					$("html, body").animate(
						{ scrollTop: sections.eq(indicatorIndex).offset().top -125 },
						settings.animDuration,
						settings.animEasing
					);
				}

				$(this)
					.removeClass(settings.indicatorIconHover)
					.addClass(settings.indicatorIcon);
			})
			.mouseover(function () {
				$(this)
					.addClass(settings.indicatorIconHover)
					.removeClass(settings.indicatorIcon);
			})
			.mouseleave(function () {
				if (!$(this).hasClass(settings.currentIndicatorClass) && !scrollingToCurr) {
					$(this)
						.removeClass(
							settings.indicatorIconActive + " " + settings.indicatorIconHover
						)
						.addClass(settings.indicatorIcon);
				} else {
					$(this)
						.removeClass(settings.indicatorIconHover)
						.addClass(settings.indicatorIcon);
				}
			});

		nextNav.click(function (e) {
			e.preventDefault();

			if (currSection == sections.length - 1) {
				scrollingToCurr = true;

				if (useVelocity) {
					$("html").velocity(
						"scroll",
						{
							offset: doc.height() - win.height(),
							duration: settings.animDuration,
							easing: settings.animEasing,
							mobileHA: false
						},
						function () {
							currSection = sections.length;
							scrollingToCurr = false;
						}
					);
				} else {
					$("html, body").animate(
						{ scrollTop: doc.height() - win.height() },
						settings.animDuration,
						settings.animEasing,
						function () {
							currSection = sections.length;
							scrollingToCurr = false;
						}
					);
				}
			} else if (currSection < sections.length - 1) {
				if (useVelocity) {
					$("html").velocity("scroll", {
						offset: sections.eq(currSection + 1).offset().top,
						duration: settings.animDuration,
						easing: settings.animEasing,
						mobileHA: false
					});
				} else {
					$("html, body").animate(
						{ scrollTop: sections.eq(currSection + 1).offset().top },
						settings.animDuration,
						settings.animEasing
					);
				}
			}
		});

		prevNav.click(function (e) {
			e.preventDefault();

			if (currSection == 0) {
				scrollingToCurr = true;

				if (useVelocity) {
					$("html").velocity(
						"scroll",
						{
							offset: 0,
							duration: settings.animDuration,
							easing: settings.animEasing,
							mobileHA: false
						},
						function () {
							currSection = -1;
							scrollingToCurr = false;
						}
					);
				} else {
					$("html, body").animate(
						{ scrollTop: 0 },
						settings.animDuration,
						settings.animEasing,
						function () {
							currSection = -1;
							scrollingToCurr = false;
						}
					);
				}
			} else if (currSection > 0) {
				if (useVelocity) {
					$("html").velocity("scroll", {
						offset: sections.eq(currSection - 1).offset().top,
						duration: settings.animDuration,
						easing: settings.animEasing,
						mobileHA: false
					});
				} else {
					$("html, body").animate(
						{ scrollTop: sections.eq(currSection - 1).offset().top },
						settings.animDuration,
						settings.animEasing
					);
				}
			}
		});

		win.scroll();
	};

	$("section").sectionIndicators();
})(jQuery);
